import {Box, Button, ButtonProps, IconButton, Stack, styled, Typography, TypographyProps} from '@mui/material'

export const NavigationButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'adminBtn',
})<ButtonProps & {active?: boolean; adminBtn?: boolean}>(({theme, active, adminBtn}) => ({
  justifyContent: 'flex-start',
  paddingLeft: adminBtn ? '3rem' : active ? '1.75rem' : '2rem',
  height: '3rem',
  borderRadius: '0',
  textTransform: 'unset',
  color: active ? theme.palette.primary.main : theme.palette.grey[100],
  ...theme.typography.body1,
  ...(active && {
    borderLeft: adminBtn ? '' : `0.25rem solid ${theme.palette.primary.main}`,
    fontWeight: 'bold',
  }),
}))

export const CustomRenderValueWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  width: '100%',
  gap: '1rem',
  justifyContent: 'flex-start',
  alignItems: 'center',
}))

export const LinkTitle = styled(Typography, {shouldForwardProp: prop => prop !== 'isLast'})<
  TypographyProps & {isLast?: boolean}
>(({theme, isLast}) => ({
  fontSize: '0.75rem',
  [theme.breakpoints.down('lg')]: {
    fontSize: '1rem',
    ...(isLast && {fontWeight: 'bold'}),
  },
}))

export const SideNavigationWrapper = styled(Stack)(({theme}) => ({
  height: '100vh',
  width: '18rem',
  backgroundColor: theme.palette.common.white,
  paddingTop: '2.5rem',
  position: 'fixed',
  top: 0,
  left: 0,
}))

export const NavigationWrapper = styled(Stack)(() => ({
  height: 'calc(100% - 8.25rem)',
  padding: '2.5rem 0 0 0.1rem',
}))

export const LogoLink = styled(Box)(() => ({
  cursor: 'pointer',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
}))

export const MainTitle = styled(Typography)(() => ({
  textAlign: 'left',
  fontWeight: 'bold',
  fontSize: '1.2rem',
}))

export const iconStyle = {
  height: '1.5rem',
  width: '1.5rem',
  paddingBottom: '0.25rem',
}

export const selectIconStyle = {
  width: 'auto',
  height: '1.2rem',
}

export const imageStyle = {
  height: '2.5rem',
}

export const TopNavigationWrapper = styled(Stack)(({theme}) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: 10,
  backgroundColor: theme.palette.common.white,
  padding: '0.75rem 1rem',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column-reverse',
    gap: '1rem',
    alignItems: 'flex-start',
  },
}))

export const TopBarRightSectionWrapper = styled(Stack)(({theme}) => ({
  flexDirection: 'row',
  gap: '1rem',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
}))

export const DropdownsWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '1rem',
  height: 54,
}))

export const DateWrapper = styled(Stack)(({theme}) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: 10,
  height: '3rem',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 1rem',
}))

export const TopBarLeftSectionWrapper = styled(Stack)(({theme}) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '1rem',
  [theme.breakpoints.down('lg')]: {
    paddingLeft: '0.75rem',
  },

  opacity: 0,
  animation: 'fadeIn 0.2s ease-out forwards',
  animationDelay: '0.2s',

  '@keyframes fadeIn': {
    from: {opacity: 0, transform: 'translateY(10px)'},
    to: {opacity: 1, transform: 'none'},
  },
}))

export const TopBarMenuButton = styled(IconButton)(({theme}) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '0.4rem',
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}))

export const DropdownLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[400],
  fontSize: '0.7rem',
  textAlign: 'start',
  paddingLeft: 5,
  marginBottom: -5,
}))

export const DropdownWrapper = styled(Stack)(() => ({
  maxWidth: 250,
  marginBottom: 5,
  opacity: 0,
  animation: 'fadeIn 0.4s ease-out forwards',

  '@keyframes fadeIn': {
    from: {opacity: 0, transform: 'translateY(10px)'},
    to: {opacity: 1, transform: 'none'},
  },
}))
